import {Action} from '@ngrx/store';
import { jobAppOpenStatusDTO } from '@staff-app/models/jobAppOpenStatusDTO';
import { jobAppProcessStatusDTO } from '@staff-app/models/jobAppProcessStatusDTO';

export enum MetaInfoActionTypes {
  Continue = '[Intro] Continue',
  GetRafCode = '[Intro] GetRafCode',
  GetJobAppOpenStatusInfo = '[Intro] Get Job App Open Status Info',
  GetJobAppOpenStatusInfoSuccessful = '[Intro] Get Job App Open Status Info Successful',
  GetJobAppProcessStatusInfo = '[Intro] Get Job App Process Status Info',
  GetJobAppProcessStatusInfoSuccessful = '[Intro] Get Job App Process Status Info Successful',
  // GetJobAppIsComplete = '[Intro] Get Job App IsComplete',
  // GetJobAppIsCompleteSuccessful = '[Intro] Get Job App Complete Successful'
}

export class Continue implements Action {
  readonly type = MetaInfoActionTypes.Continue;

  constructor(public payload: boolean) {}
}
export class GetRafCode implements Action {
  readonly type = MetaInfoActionTypes.GetRafCode;

  constructor(public payload: string) {}
}

export class GetJobAppOpenStatusInfo implements Action {
  readonly type = MetaInfoActionTypes.GetJobAppOpenStatusInfo;

  constructor() {}
}
export class GetJobAppOpenStatusInfoSuccessful implements Action {
  readonly type = MetaInfoActionTypes.GetJobAppOpenStatusInfoSuccessful;

  constructor(public payload: jobAppOpenStatusDTO) {}
}
export class GetJobAppProcessStatusInfo implements Action {
  readonly type = MetaInfoActionTypes.GetJobAppProcessStatusInfo;

  constructor(public payload: number) {}
}
export class GetJobAppProcessStatusInfoSuccessful implements Action {
  readonly type = MetaInfoActionTypes.GetJobAppProcessStatusInfoSuccessful;

  constructor(public payload: jobAppProcessStatusDTO) {}
}
// export class GetJobAppIsComplete implements Action {
//   readonly type = MetaInfoActionTypes.GetJobAppIsComplete;

//   constructor(public payload: number) {}
// }
// export class GetJobAppIsCompleteSuccessful implements Action {
//   readonly type = MetaInfoActionTypes.GetJobAppIsCompleteSuccessful;

//   constructor(public payload: boolean) {}
// }
export type MetaInfoActions =
  | Continue
  | GetRafCode
  | GetJobAppOpenStatusInfo
  | GetJobAppOpenStatusInfoSuccessful
  | GetJobAppProcessStatusInfo
  | GetJobAppProcessStatusInfoSuccessful
  // | GetJobAppIsComplete
  // | GetJobAppIsCompleteSuccessful;
  ;
